import React from 'react';

const OrderedListElement = ({ element }) => {
  const { content } = element;
  const { 
    items = ['First item', 'Second item', 'Third item'], 
    numberStyle = 'decimal', // 'decimal' | 'lower-alpha' | 'upper-alpha' | 'lower-roman' | 'upper-roman'
    alignment = 'left',
    fontSize = 'normal',
    startNumber = 1
  } = content || {};

  const style = {
    textAlign: alignment,
    fontSize: fontSize === 'small' ? '0.875rem' : fontSize === 'large' ? '1.125rem' : '1rem',
    margin: '0.5em 0',
    lineHeight: '1.6',
    paddingLeft: '1.5rem',
    listStyleType: numberStyle,
    color: 'var(--color-text)'
  };

  return (
    <ol className="builder-ordered-list" style={style} start={startNumber}>
      {items.map((item, index) => (
        <li key={index} style={{ marginBottom: '0.25rem' }}>{item}</li>
      ))}
    </ol>
  );
};

export default OrderedListElement;
